import { action } from 'satcheljs';
export default action('ON_SET_START_DATE', function (date) {
    return {
        date: date,
    };
});
//# sourceMappingURL=setStartDate.js.map